import { createContext } from 'react';

/**
 * When inputs is undefined, all form inputs are shown (backward compatible).
 * When inputs is an object, only keys with truthy values are shown.
 */
const defaultState = {
  tool: null,
  /** Optional. Object of input type keys to show in GenericQuery. Omit or use undefined to show all. */
  inputs: undefined,
  /** Optional. Override the visible question field label in GenericQuery. */
  questionLabel: undefined,
  /** Optional. Return a string or object with a message to block submit before the API request. */
  validateSubmit: undefined,
  /** Optional. String appended to the question on submit. Original question is preserved as displayQuestion. */
  promptSuffix: undefined,
  /** Optional. Override the submit endpoint used by QueryControllerProvider. */
  submitEndpoint: undefined,
  /** Optional. Transform the outgoing query payload before submit. */
  mapSubmitPayload: undefined,
  /** Optional. Document selection modes consumed by the shared document modal. */
  documentSelectionModes: undefined,
  /** Optional. Default mode used when the shared document modal opens. */
  defaultActiveDocumentSelectionMode: undefined,
  /** Optional. Called when agent auth token creation fails before submit. */
  onAuthError: undefined,
  /** Optional. Array of { question, displayQuestion } objects to pre-populate in QuerySeries mode. */
  startingQuestions: undefined,
};

export const ModeContext = createContext(defaultState);
